import type { AdminApiPlaybook } from "@repo/app-types/entities/playbook";
import type { CriteriaGradingRecord } from "@repo/app-types/entities/recording";
import { computeChapterPassRate } from "@repo/app-types/helpers/trainingAssessmentHelpers";
import { useMemo } from "react";

/**
 * Returns the pass rate for a chapter, where "passing" is defined as a score of 3 or higher
 * for 1-5 scores, or "yes" for yes/no scores.
 */
export function useChapterPassRate(
  playbook: AdminApiPlaybook | undefined,
  criteriaGrading: CriteriaGradingRecord | undefined,
) {
  return useMemo(
    () =>
      playbook && criteriaGrading
        ? computeChapterPassRate(playbook.assessment_tree, criteriaGrading)
        : undefined,
    [playbook, criteriaGrading],
  );
}
